import React from 'react';

import {NameTemplatePart} from 'name-templates/NameTemplateConstants';
import NameTemplatePartChip from 'name-templates/NameTemplatePartChip';
import {ClientSchemaField} from 'registry/field/FieldTable';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';

export interface TagSchemaNameTemplateProps {
  draggable?: boolean;
  handleDragStart?: (index: number) => void;
  handleDrop?: (index: number) => void;
  nameTemplateParts: Array<NameTemplatePart>;
  schemaFields: Array<SchemaField | ClientSchemaField>;
  // If specified, show an x on each chip and call it when the x is clicked.
  onRemovePart?: (index: number) => void;
}

function DraggableNameTemplate({
  draggable,
  handleDragStart,
  handleDrop,
  nameTemplateParts,
  schemaFields,
  onRemovePart,
}: TagSchemaNameTemplateProps): JSX.Element {
  return (
    <span>
      {nameTemplateParts.map((nameTemplatePart, i) => (
        <NameTemplatePartChip
          key={i}
          draggable={draggable}
          onDragStart={(e) => {
            if (handleDragStart) {
              handleDragStart(i);
            }
          }}
          onDragOver={(e) => {
            // Need to preventDefault here otherwise the event doesn't get propagated to onDrop
            e.preventDefault();
          }}
          onDrop={(e) => {
            if (handleDrop) {
              handleDrop(i);
            }
          }}
          nameTemplatePart={nameTemplatePart}
          schemaFields={schemaFields}
          onRemove={
            onRemovePart &&
            (() => {
              onRemovePart(i);
            })
          }
        />
      ))}
    </span>
  );
}

export default DraggableNameTemplate;
